import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../services/authentication.service';
import { environment as env } from '../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthenticationService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=UTF-8',
        'Cache-Control': 'no-cache',
        'apiKey': env.apiKey,
        'Authorization': `Bearer ` + this.auth.getToken(),
        'listall': 'true'
      })
    });

    return next.handle(request);
  }
}
